import styled from 'styled-components';
import { Margin } from 'components/base/layout-components';
import TeamAvatar from 'components/base/TeamAvatar';

const StyledTeam = styled.div`
  display: flex;
  align-items: center;
  & > .avatar {
    margin-right: 0.5rem;
  }
`;

const Team = ({ team }) => {
  return (
    <StyledTeam>
      <TeamAvatar team={team} size='small' />
      <Margin l='x-x-small'>{team?.name}</Margin>
    </StyledTeam>
  );
};

export default Team;
